import { useState, useEffect } from "react";
import State, { STATE, LoginFlowState } from "@state";
import AuthController from "@controllers/auth.controller";
import { Link, useNavigate } from "react-router-dom";
import AuthLayout from "../../../components/layout/AuthLayout";
import FormInput from "../../../components/layout/FormInput";
import Button from "../../../components/ui/Button";
import InvitationController from "@/network/controllers/invitation.controller";
import EntityController from "@/network/controllers/entity.controller";
import { useSession } from "@/hooks/useSession";

export default function UserSignUpPassword() {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [countdown, setCountdown] = useState(3);
  const navigate = useNavigate();

  const signupData = STATE[LoginFlowState.SIGNUP_USER_FORM_DATA];

  useEffect(() => {
    if (!signupData) {
      navigate("/user-signup", { replace: true });
    }
  }, [signupData, navigate]);

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
    if (error) setError("");
  };

  const handleConfirmPasswordChange = (e) => {
    setConfirmPassword(e.target.value);
    if (error) setError("");
  };

  const handleSubmit = async (e) => {
    if (isLoading) return;
    e.preventDefault();

    if (password.length < 8) {
      setError("Password must be at least 8 characters long");
      return;
    }
    if (password !== confirmPassword) {
      setError("Passwords do not match");
      return;
    }

    setIsLoading(true);
    const combinedData = { ...signupData, password, confirmPassword };

    console.log('=== combinedData === UserSignUpPassword.jsx === key: 976134 ===');
    console.dir(combinedData, { depth: null, colors: true })
    console.log('=================================');

    console.log(
      "=== combinedData === UserSignUpPassword.jsx === key: 478694 ==="
    );
    console.dir(combinedData, { depth: null, colors: true });
    console.log("=================================");
    console.log("=== STATE === UserSignUpPassword.jsx === key: 457205 ===");
    console.dir(STATE, { depth: null, colors: true });
    console.log("=================================");

    const result = await AuthController.signup(combinedData);
    setIsLoading(false);

    if (result?.success === false) {
      console.log(" fromError object:", result.fromError);
      if (Array.isArray(result.fromError?.messages)) {
        console.log(" Validation messages:", result.fromError.messages);
      }
      setError(result?.message || "Unable to create account");
      return;
    }
    return;

    try {
      console.log(
        " Full result object BEFORE userId extraction logic:",
        result
      );
      console.log(" Type of result.userId (top level):", typeof result.userId);
      console.log(
        " Type of result.webhook?.response?.data.userId:",
        typeof result.webhook?.response?.data.userId
      );

      let extractedUserId = null;
      if (
        result &&
        typeof result.userId === "string" &&
        result.userId.length > 0
      ) {
        extractedUserId = result.userId;
      } else if (
        result &&
        result.user &&
        typeof result.user.userId === "string" &&
        result.user.userId.length > 0
      ) {
        extractedUserId = result.user.userId;
      } else if (
        result &&
        result.data &&
        typeof result.data.userId === "string" &&
        result.data.userId.length > 0
      ) {
        extractedUserId = result.data.userId;
      } else if (
        result &&
        result.webhook?.response?.data &&
        typeof result.webhook.response.data.userId === "string" &&
        result.webhook.response.data.userId.length > 0
      ) {
        extractedUserId = result.webhook.response.data.userId;
      }

      if (extractedUserId) {
        State.setValue(LoginFlowState.CURRENT_USER_ID, extractedUserId);
        console.log(" userId saved to State:", extractedUserId);
      } else {
        console.warn(
          " extractedUserId is null or empty, cannot save to State."
        );
      }

      if (signupData.invitationType === "join_cro" && signupData.invitationId) {
        try {
          console.log(
            "🔗 Attempting to join invitation for CRO:",
            signupData.invitationId
          );
          const joinResult = await InvitationController.joinInvitation(
            signupData.invitationId
          );
          console.log(
            "✅ joinInvitation result:",
            JSON.stringify(joinResult, null, 2)
          );

          if (!joinResult.success) {
            console.error("❌ joinInvitation failed:", joinResult);
            setError(
              joinResult?.message || "Failed to join invitation as CRO."
            );
            return;
          }
        } catch (joinError) {
          console.error(
            "❌ Unexpected error during joinInvitation for CRO:",
            joinError
          );
          setError("Unexpected error during CRO invitation processing.");
          return;
        }
      }

      /* const siteId = signupData.assignedSiteId || null
      const croEntityId = signupData.entity_id || null

      console.log(" --- Values before registerInvestigator call ---")
      console.log(" userId (extracted):", extractedUserId)
      console.log(" siteId (from signupData):", siteId)
      console.log(" croEntityId (from signupData):", croEntityId)
      console.log(" ---------------------------------------------")

      if (extractedUserId && siteId && croEntityId) {
        console.log(" >>> Registering investigator...")
        const registerInvestigatorResult = await EntityController.registerInvestigator({
          userId: extractedUserId,
          siteId,
          croEntityId,
        })
        if (registerInvestigatorResult.success) {
          console.log(" Investigator registered successfully:", registerInvestigatorResult)
        } else {
          console.error(" Failed to register investigator:", registerInvestigatorResult)
          setError(registerInvestigatorResult?.message || "Failed to register investigator.")
        }
      } else {
        console.warn(" Missing data for investigator registration (userId, siteId, or croEntityId).")
        console.log(" The condition (userId && siteId && croEntityId) evaluated to FALSE.")
        setError("Missing essential data for investigator registration. Please try again.")
      } */

      /* console.log(" >>> About to call joinInvitation for", signupData.invitationId)
      const joinResult = await InvitationController.joinInvitation(signupData.invitationId)
      console.log(" >>> joinInvitation returned", JSON.stringify(joinResult, null, 2))

      if (!joinResult.success) {
        console.error(" Error while joinInvitation:", joinResult)
        setError(joinResult?.message || "Failed to join invitation.")
        return
      } */
    } catch (error) {
      console.error(
        " Unhandled error during investigator registration or invitation joining:",
        error
      );
      setError("An unexpected error occurred during account setup.");
    }

    State.setValue(LoginFlowState.SIGNUP_USER_DATA, null);
    setIsSubmitted(true);
  };

  return (
    <AuthLayout
      title="Create account"
      subtitle=""
      logoSrc="/img/logo.png"
      imageSrc="/img/Oshimed sign in image - earth.png"
      formWidth="third"
      logoPosition="top"
    >
      <div className="h-4"> </div>
      {!isSubmitted ? (
        <>
          {error && (
            <div className="mb-4 p-3 bg-red-50 border border-red-200 text-red-700 rounded-md">
              {error}
            </div>
          )}
          <form className="space-y-4" onSubmit={handleSubmit}>
            <FormInput
              label="Password"
              id="password"
              name="password"
              type="password"
              placeholder="At least 8 characters"
              value={password}
              onChange={handlePasswordChange}
              required
            />
            <FormInput
              label="Re-enter password"
              id="confirmPassword"
              name="confirmPassword"
              type="password"
              placeholder="Repeat your password"
              value={confirmPassword}
              onChange={handleConfirmPasswordChange}
              required
            />
            <Button
              type="submit"
              variant="login"
              disabled={isLoading}
              className={`w-full font-semibold flex items-center justify-center hover:shadow-md hover:translate-y-[-2px] ${
                isLoading ? "opacity-60 cursor-not-allowed" : ""
              }`}
            >
              {isLoading ? (
                <svg
                  className="animate-spin h-5 w-5 text-white"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                  ></circle>
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8v4l3-3-3-3v4a8 8 0 100 16v-4l-3 3 3 3v-4a8 8 0 01-8-8z"
                  />
                </svg>
              ) : (
                "Confirm Password"
              )}
            </Button>
          </form>
        </>
      ) : (
        <div className="text-center py-8">
          <div className="w-16 h-16 bg-green-100 rounded-full mx-auto flex items-center justify-center mb-4">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-8 w-8 text-green-600"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M5 13l4 4L19 7"
              />
            </svg>
          </div>
          <h3 className="text-lg font-medium text-gray-900 mb-2">
            Password set successfully!
          </h3>
          <p className="text-sm text-gray-600 mb-4">
            Your password has been set correctly.
          </p>
        </div>
      )}
      <div className="h-20"></div>
      <div className="h-2"></div>
      <div className="mb-6 pt-8 text-center">
        <p> By creating an account, you agree to Oshimed's</p>
        <Link
          to="/condition-use"
          className="text-linkColor font-semibold hover:underline"
        >
          Conditions of use
        </Link>
      </div>
      <div className=" text-center">
        <p className="text-gray-600 font-bold">
          You already have an account?{" "}
          <Link
            to="/user-signin"
            className="text-linkColor font-semibold hover:underline"
          >
            Sign in
          </Link>
        </p>
      </div>
    </AuthLayout>
  );
}
